import React, { useEffect, useState } from "react";

import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { useNavigate } from "react-router-dom";

import { NFTContarct } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";

 
import { FaWallet, FaHashtag, FaMoneyBillWave, FaBoxOpen, FaClock, FaCopy, FaCheck } from "react-icons/fa";
import Loader from "../components/Loader"; // 🔥 Import your Loader component

const TopDailyTraders = () => {
    const navigate = useNavigate();  // ⭐ Added
  
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [traders, setTraders] = useState([]);
  const [loading, setLoading] = useState(true);
   const [poolValue, setPoolValue] = useState("0.00"); // ⭐ New State for tPool
  const [activeTab, setActiveTab] = useState("Leaderboard");


  const formatBalance = (balance) => balance ? parseFloat(balance).toFixed(2) : "0.00";

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "TradeHistory") {
      navigate("/my-nft-history");  
    } else if (tab === "All NFTs") {
      navigate("/nft-market-place");    // ⭐ FIXED
    }
  };

  // Initialize Web3
  useEffect(() => {
    let provider = null;
    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;
    if (!provider) return;

    setWeb3(new Web3(provider));
  }, [client]);

  // Fetch Top 10 Daily Traders
  const fetchTopTraders = async () => {
    if (!web3) return;
    setLoading(true);

    try {
      const contract = new web3.eth.Contract(NFTABI, NFTContarct);

      const result = await contract.methods.getTop10DailyTraders().call();
      console.log("RAW RESULT:", result);

      const topUsers = result[0].map((u) => (Array.isArray(u) ? u[0] : u));
      const volumes = result[1].map((v) =>
        web3.utils.fromWei(v.toString(), "ether")
      );

      const formatted = topUsers.map((user, idx) => ({
        rank: idx + 1,
        address: user,
        volume: volumes[idx],
      }));

      setTraders(formatted);
    } catch (error) {
      console.error("Error fetching top traders:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTPool = async () => {
    if (!web3) return;

    try {
      const contract = new web3.eth.Contract(NFTABI, NFTContarct);
      const result = await contract.methods.getTPool().call();
      console.log("getTPool() =>", result);

      const readableValue = web3.utils.fromWei(result.toString(), "ether");
      setPoolValue(formatBalance(readableValue));
    } catch (error) {
      console.error("Error fetching tPool:", error);
    }
  };

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
      setCopiedIndex(null);
    }, 1500);
  };
  useEffect(() => {
    if (isConnected && web3) fetchTopTraders();      fetchTPool(); // ⭐ Call to get tPool value

  }, [isConnected, web3]);

  if (loading) return <Loader />; // 🔥 Show loader while fetching
 

  return (
    <div className="page"> 
      <div className="pageTitle">
        <div className="section-title">
          <h2>
            <span>Top 10 Daily Traders</span>
          </h2>
        </div>
      </div>

        {/* Tabs */}
      <div className="filter-left">
        {["All NFTs", "Leaderboard", "TradeHistory"].map((tab) => (
          <a
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        ))}
      </div>

  <div className="col-12 mt-3">
  <div style={{
    background: "#1b1f24",
    color: "white",
    padding: "15px 20px",
    borderRadius: "8px",
    border: "1px solid #2d3238",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "18px",
    fontWeight: "600"
  }}>
    <span>💰 Total Leader Pool</span>
    <span style={{ color: "#00ff9d", fontSize: "20px" }}>
      {poolValue ? `${poolValue} USDT` : "Loading..."}
    </span>
  </div>
</div>

      <div className="mt-3">
      <div className="row">
  {traders.length > 0 ? (
    traders.map((t, idx) => {
      // MASK LOGIC (kept 100% same as your table)
      const maskedAddress =
        t.address === "0x0000000000000000000000000000000000000000"
          ? "---"
          : `${t.address.slice(0, 6)}...${t.address.slice(-4)}`;

      return (
        <div className="col-md-4 mb-4" key={idx}>
          {/* CARD */}
          <div className="ref-card">
            <div className="ref-card-body">

              {/* RANK */}
              <div className="ref-row">
                <span className="ref-label">
                  <FaHashtag className="ref-icon" /> Rank
                </span>
                <span className="ref-value">{t.rank}</span>
              </div>

              {/* ADDRESS + COPY */}
              <div className="ref-row">
                <span className="ref-label">
                  <FaWallet className="ref-icon" /> Address
                </span>

                <div className="ref-copy-box">
                  <span className="ref-value">{maskedAddress}</span>

                  {t.address !==
                  "0x0000000000000000000000000000000000000000" ? (
                    <button
                      className="copy-btn"
                      onClick={() => handleCopy(t.address, idx)}
                    >
                      {copiedIndex === idx ? (
                        <FaCheck className="copy-icon copied" />
                      ) : (
                        <FaCopy className="copy-icon" />
                      )}
                    </button>
                  ) : null}
                </div>
              </div>

              {/* DAILY TRADE VOLUME */}
              <div className="ref-row">
                <span className="ref-label">
                  <FaMoneyBillWave className="ref-icon" /> Daily Volume (USDT)
                </span>
                <span className="ref-badge">{formatBalance(t.volume)}</span>
              </div>

            </div>
          </div>
        </div>
      );
    })
  ) : (
    <div className="col-12 text-center mt-3">
      <div className="alert alert-warning">No traders found</div>
    </div>
  )}
</div>

          {/* <table className="table table-striped table-bordered">
            <thead className="table-dark">
              <tr>
                <th>Rank</th>
                <th>Address</th>
                <th>Daily Trade Volume (USDT)</th>
              </tr>
            </thead>
            <tbody>
              {traders.length > 0 ? (
                traders.map((t, idx) => (
                  <tr key={idx}>
                    <td>{t.rank}</td>
                    <td>
                      {t.address ===
                      "0x0000000000000000000000000000000000000000"
                        ? "---"
                        : `${t.address.slice(0, 6)}...${t.address.slice(-4)}`}
                    </td>
                    <td>{t.volume}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No traders found
                  </td>
                </tr>
              )}
            </tbody>
          </table> */}
       
      </div>
    </div>
  );
};

export default TopDailyTraders;
